(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["non-b2b-popup"] && !Shopify.designMode) return;
  try {
    
  class NonB2BPopup extends HTMLElement {
    constructor() {
      super();
      this.delay = 2500;
      this.closeHandler = () => this.dialog?.close();
      this.openModalHandler = () => this.openModal();
    }
    connectedCallback() {
      const delayValue = parseInt(this.getAttribute('delay'), 10);
      this.delay = !isNaN(delayValue) ? delayValue : 2500;
      this.dialog = this.querySelector('.non-b2b-popup');

      if (this.dialog) {
        this.init();
        this.querySelector('.non-b2b-popup-close')?.addEventListener('click', this.closeHandler);
      }
    }
    disconnectedCallback() {
      this.querySelector('.non-b2b-popup-close')?.removeEventListener('click', this.closeHandler);
      document.removeEventListener('DOMContentLoaded', this.openModalHandler);
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    }
    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.openModalHandler);
      } else {
        this.openModal();
      }
    }
    openModal() {
      this.timeoutId = setTimeout(() => {
        if (this.dialog && !this.dialog.open) {
          this.dialog.showModal();
        }
      }, this.delay);
    }
  }
  customElements.define('non-b2b-popup', NonB2BPopup);

  } catch(e) { console.error(e); }
})();
})();
